export default window.posthog